import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {ApiService} from '../api-service';
import {AboutcedlabStore} from './aboutcedlab.store';
import {ConstantsStore} from '../constants.store';
import {TableInfo} from '../../../models/tableInfo';
import {AboutCedlab} from '../../../models/AboutCedlab';

@Injectable({
  providedIn: 'root'
})
export class AboutcedlabService {


  constructor(
    private apiService: ApiService,
    private store: AboutcedlabStore,
    private constants: ConstantsStore
  ) { }


  /* CRUD Operations */
  getAboutCedlab(): Observable<boolean> {
    return new Observable(observer => {
      this.apiGet()
        .subscribe(
          res => {
            this.store.loadInfo(res);
            observer.next(true);
          },
          (err) => {
            observer.error(err);
          },
          () => { }
        );
    });
  }
  updateInfo(toUpdate: AboutCedlab): Observable<boolean> {
    return new Observable(observer => {
      this.apiPut(toUpdate)
        .subscribe(
          () => {
            this.store.updateInfo(toUpdate);
            observer.next(true);
          },
          err => {
            observer.error(err);
          },
          () => { }
        );
    });
  }

  /* Search Operations */
  isThereInfo(tableTitle: string): boolean {
    let description = '';
    this.store.aboutCedlab.forEach(i => {
      if (i.sezione === tableTitle) {
        description = i.descrizione;
      }
    });
    return description !== '';
  }
  findSection(sezione: string): AboutCedlab {
    let aboutCedlab: AboutCedlab = {
      id: 0,
      sezione: '',
      descrizione: ''
    };
    this.store.aboutCedlab.forEach(t => {
      if (t.sezione === sezione) {
        aboutCedlab = t;
      }
    });
    return aboutCedlab;
  }

  /* API Calls*/
  apiGet() {
    return this.apiService.get<AboutCedlab[]>(this.constants.aboutCedlabUrl);
  }
  apiPut(infoToUpdate: AboutCedlab) {
    return this.apiService.put<AboutCedlab>(this.constants.aboutCedlabUrl, infoToUpdate);
  }

}
